import { useLogout } from '../../lib/session';

interface HeaderProps {
  title: string;
  subtitle?: string;
}

export const Header = ({ title, subtitle }: HeaderProps) => {
  const logout = useLogout();

  return (
    <header className="shrink-0 border-b border-extranet-border bg-extranet-card px-8 py-5 flex items-center justify-between">
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-extranet-text-primary">{title}</h1>
        {subtitle ? <p className="text-extranet-text-secondary text-sm mt-1">{subtitle}</p> : null}
      </div>

      <button
        type="button"
        onClick={() => void logout()}
        className="text-sm text-extranet-text-secondary hover:text-extranet-text-primary transition"
      >
        Déconnexion
      </button>
    </header>
  );
};
